/* eslint-disable react/no-array-index-key */
import React from 'react'
import { graphql } from 'gatsby'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import { Layout, Meta } from '../components/layout'
import { Hero, PartnersBlock, FeatureBlock, AppsBlock, SupportBlock } from '../components/pages/homepage'
import { RelativeContainer, ComponentContainer } from '../components/shared/landingPages/layoutComponents'
import ShineMobileAppImage from '../images/home/hero/ShineMobileAppImage.jpg'
import { reviewStructuredData } from '../components/layout/meta/schema-org'
import theme from '../theme'
import GettingStarted from '../components/pages/homepage/gettingStarted'

const GettingStartedData = {
    img: ShineMobileAppImage,
    title: `Je bedrijf groeit, je tools moeten meegroeien`,
    text: `Van het team achter Tellow: Shine is je nieuwe financiële copiloot, met nog meer slimme manieren om je business te beheren en te laten groeien.
    
Meld je aan voor Shine en krijg vier weken gratis toegang tot intuïtieve nieuwe functies.`,
    textCTA: `Start met Shine`,
    url: `https://shine.co/nl?utm_source=tellow&utm_medium=home_hero&utm_campaign=tellow_shine_organic`,
}

const Home = ({ data }) => {
    const home = data?.prismicHome.data

    return (
        <Layout color={theme.color.tellowPurple}>
            <Meta
                keywords={['boekhoudprogramma', 'online boekhouden', 'boekhoudprogramma zzp', 'online boekhoudprogramma', 'online boekhouden zzp']}
                title={home.meta_title.text}
                description={home.meta_desc.text}
                path="/"
                jsonLD={reviewStructuredData}
            />
            {home.body.map((slice, idx) => {
                switch (slice.slice_type) {
                    case 'hero':
                        return (
                            <React.Fragment key={`${slice.id}-${idx}`}>
                                <Hero className="hero" content={slice} />
                                <RelativeContainer>
                                    <ComponentContainer>
                                        <GettingStarted data={GettingStartedData} showWebinatButton />
                                    </ComponentContainer>
                                </RelativeContainer>
                            </React.Fragment>
                        )
                    case 'featureblock':
                        return <FeatureBlock className="featureblock" key={`${slice.id}-${idx}`} content={slice} />
                    case 'appsblock':
                        return <AppsBlock className="appsblock" key={`${slice.id}-${idx}`} content={slice} />
                    case 'partnersblock':
                        return <PartnersBlock className="partnersblock" key={`${slice.id}-${idx}`} content={slice} />
                    case 'supportblock':
                        return <SupportBlock className="supportblock" key={`${slice.id}-${idx}`} content={slice} />
                    default:
                        return null
                }
            })}
        </Layout>
    )
}
export default withPrismicPreview(Home)

export const query = graphql`
    {
        prismicHome {
            _previewable
            data {
                body {
                    ... on PrismicHomeDataBodyHero {
                        id
                        slice_type
                        primary {
                            title_1 {
                                text
                            }
                            title_2 {
                                text
                            }
                            description {
                                text
                            }
                            main_image {
                                url
                                alt
                            }
                            placeholder {
                                text
                            }
                            copy_waiting_time {
                                text
                            }
                            signup_button {
                                text
                            }
                        }
                    }
                    ... on PrismicHomeDataBodyFeatureblock {
                        id
                        slice_type
                        items {
                            functions_name {
                                text
                            }
                            explanation {
                                text
                            }
                            function_image {
                                url
                            }
                            icon_name {
                                text
                            }
                            path {
                                text
                            }
                        }
                        primary {
                            functions {
                                text
                            }
                            sub_function {
                                text
                            }
                        }
                    }
                    ... on PrismicHomeDataBodyAppsblock {
                        id
                        slice_type
                        primary {
                            app_title {
                                text
                            }
                            review_buton {
                                text
                            }
                            announcer {
                                text
                            }
                            app_title_after_freelancer_number {
                                text
                            }
                            primary_button {
                                text
                            }
                        }
                    }
                    ... on PrismicHomeDataBodyPartnersblock {
                        id
                        slice_type
                        items {
                            partners_image {
                                url
                            }
                        }
                        primary {
                            main_title_white {
                                text
                            }
                            main_title_green {
                                text
                            }
                            description {
                                text
                            }
                            gratis_button {
                                text
                            }
                        }
                    }
                    ... on PrismicHomeDataBodySupportblock {
                        id
                        slice_type
                        primary {
                            support_title {
                                text
                            }
                            description {
                                text
                            }
                            call_button {
                                text
                            }
                            button_href {
                                url
                            }
                            change_offer {
                                text
                            }
                            success_announcer {
                                text
                            }
                        }
                    }
                }
                meta_desc {
                    text
                }
                meta_title {
                    text
                }
            }
            uid
        }
    }
`
